<template>
  <div class="management-sidebar-item">
    <v-layout
      row
      align-center
      class="management-sidebar-title"
      :class="{ activeTab: activeTab }"
      @click="toggleMenuItem"
    >
      <slot name="icon" />

      <span class="sidebar-title">{{ item.name }}</span>
    </v-layout>

    <slot name="subMenu" />
  </div>
</template>

<script>
export default {
  name: "ManagementSidebarMenuItem",

  props: ["item", "selected"],

  computed: {
    activeTab() {
      if (this.selected && this.item) {
        return this.selected.name === this.item.name;
      }
      return false;
    }
  },

  methods: {
    toggleMenuItem() {
      this.$emit("toggle", this.item);
    }
  }
};
</script>

<style scoped>
.management-sidebar-item {
  position: relative;
  text-align: left;
}

.management-sidebar-title {
  width: 100%;
  padding-left: 20px;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  transition: 0.3s all;
  cursor: pointer;
}

.management-sidebar-title:before {
  position: absolute;
  content: "";
  display: inline-block;
  width: 7px;
  height: 7px;
  border-right: 1px solid #b1b6b9;
  border-top: 1px solid #b1b6b9;
  transform: rotate(135deg);
  left: 182px;
  top: 16px;
  transition: 0.5s all;
}

.sidebar-title {
  padding-left: 15px;
  font-size: 16px;
  font-weight: 300;
  margin: 10px 0;
  width: 135px;
}
</style>



// WEBPACK FOOTER //
// src/components/Management/Sidebar/SidebarMenuItem.vue